module.exports = __webpack_public_path__ + "static/media/28.0aaa6c63.mp3";